import angular from 'angular';
import oneLineText from './oneLineText';
import './style.scss';

export default angular
  .module('components.oneLineText', [])
  .component('oneLineText', oneLineText).name;
